module.exports = __webpack_public_path__ + "img/no_order.e2e0b21e.png";